<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

<ng-template #legendTemplate>
  <!-- ✅ RIMOSSO: Bottone export custom -->
  <!-- Il bottone export viene ora gestito automaticamente nella toolbar -->
  <!-- tramite CtExportConfiguration nella configuration -->
  
  <!-- Se in futuro servono altri bottoni custom nella legend, aggiungerli qui -->
</ng-template>

<!--
  Template custom della cella "Description".
  Il backend invia il testo con sequenze `\r\n` per indicare i ritorni a capo:
  con `white-space: pre-wrap` li onoriamo nativamente senza dover trasformare
  il contenuto in HTML (niente innerHTML → niente rischio XSS, niente sanitization).
  Il template viene poi attaccato alla colonna tramite `setFieldsCustomTemplates(...)`.
-->
<ng-template #descriptionCellTpl let-value="value">
  <!--
    `width: 100%` è indispensabile: il framework applica
    `display: flex; justify-content: center; align-items: center` su
    `.datatable-body-cell .datatable-body-cell-label` (vedi
    ct-datatable.component.scss). Senza width: 100% lo span si dimensiona
    al contenuto e viene centrato dal flex padre, vanificando il text-align.
  -->
  <span style="display: block; width: 100%; text-align: left; white-space: pre-wrap;">{{ value }}</span>
</ng-template>
